import ConfirmationButtons from "@/common/ConfirmationButtons";
import { Container } from "@/common/ui/container";
import OTPInputBox from "@/common/ui/otp/OTPInputBox";
import ResendOTP from "@/common/ui/otp/ResendOTP";
import { privateResendCode, verifyMfa } from "@/services/common/security.services";
import { toastMessage } from "@/utils/helper/myToast";
import React, { useState } from "react";

interface SmsMfaSetupProps {
  onClose: (props?: any) => void;
  mfaDetails: { phoneVerifyToken: string; maskIdentity: string };
}

const SmsMfaSetup: React.FC<SmsMfaSetupProps> = ({ onClose, mfaDetails }) => {
  const [otp, setOtp] = useState("");
  const [resetCount, setResetCount] = useState(0);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleVerify = async () => {
    setIsLoading(true);
    try {
      const { phoneVerifyToken } = mfaDetails;
      const res: any = await verifyMfa({ totp: otp, phoneVerifyToken, mfaType: "SMS" });
      if (res?.status === 200) {
        const { message, isError } = res.data;
        onClose();
        return toastMessage(message, isError);
      } else if (res?.response?.status === 401) {
        const { message } = res?.response?.data || {};
        setError(message);
        return;
      } else {
        console.log("Error", res);
        const { message } = res?.response?.data || {};
        if (message) {
          setError(message);
        }
        if (res.message) {
          return toastMessage(res.message, true);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };
  const resendOtp = async () => await privateResendCode({ token: mfaDetails.phoneVerifyToken }, "?key=register-sms-mfa");

  return (
    <Container.ContentBox>
      <Container.Content>
        <p className=" text-center py-5 text-13 text-text-label">
          We've sent an OTP to the number ending with <span className="font-medium text-nowrap">{mfaDetails?.maskIdentity}</span>. <br />
          Please enter it below.
        </p>
        <OTPInputBox resetCount={resetCount} setCompleteOtp={setOtp} errorMessage={error} resetErrorMessage={() => setError("")} />
        <ResendOTP resendOtpAPI={resendOtp} setResetCount={setResetCount} errorMessage={error} resetErrorMessage={() => setError("")} />
      </Container.Content>
      <Container.Separator />
      <ConfirmationButtons handleConfirm={handleVerify} handleCancel={onClose} confirmText="Verify" disabled={!otp} isLoading={isLoading} />
    </Container.ContentBox>
  );
};

export default SmsMfaSetup;
